import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { RachelAskUserAnswerEntry } from '../../../../../rachelAskUser.utils';

interface RachelAskUserSummaryProps {
  entries: RachelAskUserAnswerEntry[];
}

const RachelAskUserSummary = ({ entries }: RachelAskUserSummaryProps) =>
  entries.length === 0 ? null : (
    <Stack
      gap={1}
      test-id="rachel-ask-user-summary"
      sx={(theme) => ({
        alignSelf: 'flex-start',
        maxWidth: '100%',
        py: 0.75,
        px: 1.25,
        borderRadius: `${theme.shape.borderRadius2xl}px`,
        backgroundColor: theme.palette.action.hover,
      })}
    >
      {entries.map(({ question, answer }, index) => (
        <Stack key={`${index}-${question}`} gap={0.25}>
          <Typography variant="body1" color="text.secondary" sx={{ overflowWrap: 'anywhere' }}>
            {question}
          </Typography>
          <Typography variant="body1" color="text.primary" sx={{ overflowWrap: 'anywhere' }}>
            {answer}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );

export default RachelAskUserSummary;
